export class PermittedAppsModel{
  permittedApps:any = []
}
